import React from "react";
import { Skeleton } from "../ui/skeleton";
import "../../styles/SharedStates.css";

export default function LoadingState({ variant = "list", label = "Loading...", rows = 4 }) {
  return (
    <div className={`admin-loading-state admin-loading-state--${variant}`} role="status" aria-busy="true" aria-live="polite">
      <div className="admin-loading-state__heading">
        <span className="admin-loading-state__spinner" aria-hidden="true" />
        <span>{label}</span>
      </div>
      <div className="admin-loading-state__skeletons" aria-hidden="true">
        {Array.from({ length: rows }, (_, index) => <Skeleton key={index} className="admin-loading-state__row" />)}
      </div>
    </div>
  );
}
